import { FC, useEffect } from 'react';

import { getSelectedForms, getSelectedNamedForms } from '@features/formsSlice';
import useTranslateForm from '@hooks/useTranslateForm';
import NewOrderBase from '@routes/NewOrder/NewOrderBase';
import { ROUTES } from '@routes/constants';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const NewOrderForms: FC = () => {
  const selectedForms = useSelector(getSelectedForms);
  const { mutateAsync, isLoading, error, isError, reset } = useTranslateForm();
  const navigate = useNavigate();

  const namedSelected = useSelector(getSelectedNamedForms);

  useEffect(() => {
    if (!selectedForms || !selectedForms.length) navigate(ROUTES.EMAILS);
  }, [selectedForms, navigate]);

  return (
    <NewOrderBase
      type={'forms'}
      mutationError={error}
      mutationIsError={isError}
      mutationIsLoading={isLoading}
      mutationReset={reset}
      selected={selectedForms}
      onSend={(data) => mutateAsync({ ...data, ids: selectedForms })}
      namedSelected={namedSelected}
    />
  );
};

export default NewOrderForms;
